import React, { Component } from "react";

export default class Liising extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: 0,
    };
  }

  addInfo = () => {
    const { data } = this.props;
    if (data.model === "Macan" || data.model === "Taycan") {
      return (
        <p>
          Näidismakse sõidukile hinnaga 150 000€. SEB liisinguintress 1,45% + 6k
          Euribor *Liisingu igakuine kuumakse on 1 439 € 60 kuulise lepingu
          korral ja krediidi kulukuse esialgne määr 4,76% aastas järgmistel
          kasutusrendi tüüpi liisingfinantseerimise näidistingimustel: sõiduk
          hinnaga 150 000€ koos käibemaksuga; sissemakse 30 000€ eurot (20%
          sõiduki hinnast); jääkväärtus 35% sõiduki hinnast; kasutusse võetav
          krediidisumma koos käibemaksuga 67 500€; intressimäär 4,220% aastas
          krediidijäägilt (intressimäär koosneb 6 kuu euriborist ja marginaalist
          1,45%; 01.09.2026 seisuga oli kuue kuu euribor 2.779%; lepingus
          fikseeritud euribor võib muutuda iga kuue kuu järel, marginaal on
          fikseeritud lepingu lõpuni); tagastamine viie aasta jooksul 60
          igakuise annuiteetmaksena, jääkväärtus tasutakse liisinguperioodi
          lõpus; lepingu sõlmimise tasu on 1% sõidukihinnast aga mitte vähem kui
          225€. Kliendi makstav tagasimaksete summa on 87 875€ ja maksete
          kogusumma on 170 375€.
          <br /> <br />
          Finantsteenuse pakkuja on AS SEB Liising, tegemist on tüüpnäitega ja
          tegelikud pakutavad tingimused võivad erineda. Enne lepingu sõlmimist
          tutvuge tingimustega{" "}
          <a
            href="www.seb.ee/eraklient/laenud/liising"
            target="_blank"
            rel="noreferrer"
          >
            www.seb.ee/eraklient/laenud/liising
          </a>{" "}
          ja vajadusel konsulteerige pangatöötaja või meie müügikonsultandiga.
          Teil on õigus alati küsida infot liisingutingimuste kohta ja saada
          selgitusi nii enne liisingulepingu sõlmimist kui ka selle kehtivuse
          ajal. Meie müügikonsultandid aitavad teid igas küsimuses.
        </p>
      );
    }
    if (data.model === "Panamera" || data.model === "Cayenne") {
      return (
        <p>
          Näidismakse sõidukile hinnaga 150 000€. SEB liisinguintress 1,55% + 6k
          Euribor *Liisingu igakuine kuumakse on 1 447 € 60 kuulise lepingu
          korral ja krediidi kulukuse esialgne määr 4,87% aastas järgmistel
          kasutusrendi tüüpi liisingfinantseerimise näidistingimustel: sõiduk
          hinnaga 150 000€ koos käibemaksuga; sissemakse 30 000€ eurot (20%
          sõiduki hinnast); jääkväärtus 35% sõiduki hinnast; kasutusse võetav
          krediidisumma koos käibemaksuga 67 500€; intressimäär 4,320% aastas
          krediidijäägilt (intressimäär koosneb 6 kuu euriborist ja marginaalist
          1,55%; 01.09.2026 seisuga oli kuue kuu euribor 2.779%; lepingus
          fikseeritud euribor võib muutuda iga kuue kuu järel, marginaal on
          fikseeritud lepingu lõpuni); tagastamine viie aasta jooksul 60
          igakuise annuiteetmaksena, jääkväärtus tasutakse liisinguperioodi
          lõpus; lepingu sõlmimise tasu on 1% sõidukihinnast aga mitte vähem kui
          225€. Kliendi makstav tagasimaksete summa on 88 372€ ja maksete
          kogusumma on 170 872 €.
          <br /> <br />
          Finantsteenuse pakkuja on AS SEB Liising, tegemist on tüüpnäitega ja
          tegelikud pakutavad tingimused võivad erineda. Enne lepingu sõlmimist
          tutvuge tingimustega{" "}
          <a
            href="www.seb.ee/eraklient/laenud/liising"
            target="_blank"
            rel="noreferrer"
          >
            www.seb.ee/eraklient/laenud/liising
          </a>{" "}
          ja vajadusel konsulteerige pangatöötaja või meie müügikonsultandiga.
          Teil on õigus alati küsida infot liisingutingimuste kohta ja saada
          selgitusi nii enne liisingulepingu sõlmimist kui ka selle kehtivuse
          ajal. Meie müügikonsultandid aitavad teid igas küsimuses.
        </p>
      );
    }
    if (
      data.model === "911" ||
      data.model === "718" ||
      data.model === "718 Cayman"
    ) {
      return (
        <p>
          Näidismakse sõidukile hinnaga 150 000€. SEB liisinguintress 1,85% + 6k
          Euribor *Liisingu igakuine kuumakse on 1 469 € 60 kuulise lepingu
          korral ja krediidi kulukuse esialgne määr 5,19% aastas järgmistel
          kasutusrendi tüüpi liisingfinantseerimise näidistingimustel: sõiduk
          hinnaga 150 000€ koos käibemaksuga; sissemakse 30 000€ eurot (20%
          sõiduki hinnast); jääkväärtus 35% sõiduki hinnast; kasutusse võetav
          krediidisumma koos käibemaksuga 67 500€; intressimäär 4,620% aastas
          krediidijäägilt (intressimäär koosneb 6 kuu euriborist ja marginaalist
          1,85%; 01.09.2026 seisuga oli kuue kuu euribor 2.779%; lepingus
          fikseeritud euribor võib muutuda iga kuue kuu järel, marginaal on
          fikseeritud lepingu lõpuni); tagastamine viie aasta jooksul 60
          igakuise annuiteetmaksena, jääkväärtus tasutakse liisinguperioodi
          lõpus; lepingu sõlmimise tasu on 1% sõidukihinnast aga mitte vähem kui
          225€. Kliendi makstav tagasimaksete summa on 89 687€ ja maksete
          kogusumma on 172 187 €.
          <br /> <br />
          Finantsteenuse pakkuja on AS SEB Liising, tegemist on tüüpnäitega ja
          tegelikud pakutavad tingimused võivad erineda. Enne lepingu sõlmimist
          tutvuge tingimustega{" "}
          <a
            href="www.seb.ee/eraklient/laenud/liising"
            target="_blank"
            rel="noreferrer"
          >
            www.seb.ee/eraklient/laenud/liising
          </a>{" "}
          ja vajadusel konsulteerige pangatöötaja või meie müügikonsultandiga.
          Teil on õigus alati küsida infot liisingutingimuste kohta ja saada
          selgitusi nii enne liisingulepingu sõlmimist kui ka selle kehtivuse
          ajal. Meie müügikonsultandid aitavad teid igas küsimuses.
        </p>
      );
    }

    return " ";
  };

  addHinnaklass = () => {
    const { data } = this.props;

    if (data.manual_kasko_kuumakse) {
      return <>al. {data.manual_kasko_kuumakse} € kuu</>;
    }

    if (data.eripakkumine === "115000.00") {
      return <>al. 1300 € aasta / al. 108,33 € kuu</>;
    }
    if (data.eripakkumine === "125000.00") {
      return <>al. 1450 € aasta / al. 120,83 € kuu</>;
    }
    if (data.eripakkumine === "130000.00") {
      return <>al. 1450 € aasta / al. 120,83 € kuu</>;
    }
    if (data.eripakkumine === "140000.00") {
      return <>al. 1600 € aasta / al. 133,33 € kuu</>;
    }
    return " ";
  };

  render() {
    const { data } = this.props;
    return (
      <>
        {this.addInfo()}

        <p>
          <br />
          IIZI Kindlustusmaakler AS, LHV näidismakse
          <br />
          <br />
          {this.addHinnaklass()}
          <br />
          Standard Kasko – asendussõidukikindlustus ja uusväärtuskindlustus on
          hinnas
          <br />
          Omavastutus – põhiomavastutus 300 eurot, klaasikahjud 10% omavastutus,
          metsloomaga kokkupõrge põhiomavastutus, varguse ja röövi omavastutus
          15%.
          <br />
          Kindlustusperiood - 1 aasta
          <br />
          Kasutusala – tavakasutus
          <br />
          Käesolev kindlustuspakkumine on koostatud Auto 100 poolt avaldatud
          kindlustushuvi alusel, eesmärgiga toetada perioodil 17.11 kuni 31.01
          toimuvat Porsche sõidukite müügikampaaniat.
          <br />
          Kui teie kindlustushuvi on sellest erinev, andke meile sellest
          kindlasti teada ja saame koostada teie kindlustushuvile vastava
          pakkumuse.
        </p>
      </>
    );
  }
}
